import {GameInfoButtonDefaultBox} from './game-info-button.default.box';
import {GameInfoButtonCasino777Box} from './game-info-button.casino777.box';
import {styledByTheme} from '../../../../../../themes/architecture/styled-by-theme';

export const GameInfoButtonBox = styledByTheme(GameInfoButtonDefaultBox).forCasino777(GameInfoButtonCasino777Box).apply();